const EmptyPage = ({
  img_src,
  header,
  text,
  button
}) => (
  <div className='control_empty'>
    <img className='control_empty_image' src={img_src} />
    <p className='control_empty_message_header'>{header}</p>
    <p>{text}</p>
    {button &&
      <a href={button.link} className='btn btn-primary control_empty--btn'>{button.text}</a>}
  </div>
)

export default EmptyPage
